(() => {
  const dialog = document.getElementById('LaunchSignup');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const key = 'yves-launch-signup-dismissed';
  let previousFocus;

  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
  };

  dialog.querySelector('.launch-signup__close')?.addEventListener('click', () => dialog.close());
  document.querySelector('[data-launch-open]')?.addEventListener('click', open);

  // Save the phone number on the customer profile as a tag (e.g. phone-2135550123).
  const form = dialog.querySelector('form');
  form?.addEventListener('submit', () => {
    const phone = form.querySelector('[data-launch-phone]');
    const tags = form.querySelector('[data-launch-tags]');
    const digits = (phone?.value || '').replace(/[^0-9+]/g, '');
    if (tags && digits) tags.value = `newsletter,puffpuff-launch,phone-${digits}`;
  });

  dialog.addEventListener('close', () => {
    try {
      localStorage.setItem(key, String(Date.now()));
    } catch (_) {
      /* Storage can be unavailable. */
    }
    previousFocus?.focus?.();
  });

  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    const outside =
      event.clientX < bounds.left ||
      event.clientX > bounds.right ||
      event.clientY < bounds.top ||
      event.clientY > bounds.bottom;
    if (outside) dialog.close();
  });

  // After submitting, the page reloads; reopen to show the code or error.
  if (dialog.querySelector('[data-success], [role="alert"]')) {
    open();
    return;
  }

  let dismissed = false;
  try {
    dismissed = Date.now() - Number(localStorage.getItem(key) || 0) < 7 * 86400000;
  } catch (_) {
    /* Default to showing the signup. */
  }

  if (!dismissed) {
    setTimeout(() => {
      if (!document.querySelector('dialog[open]')) open();
    }, 4000);
  }
})();
